<script>
	import { onMount } from "svelte";
	import { Col, Row } from "sveltestrap";
	import GroupDetailsCard from "./GroupDetailsCard.svelte";
	import GroupMemberTable from "./GroupMemberTable.svelte";
	import { loading } from "../../../store/store";
	import client from "../../../services/client";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
</script>

<Row>
	<Col>
		<Col className="row d-flex align-items-start mx-0">
			<h5>Group Details</h5>
		</Col>
		<Row>
			<Col xs={4}>
				<GroupDetailsCard />
			</Col>
			<Col xs={8}>
				<GroupMemberTable />
			</Col>
		</Row>
	</Col>
</Row>
